<template>
  <div class="red-packet1-dialog">
    <div class="red-packet1-content" slot="custom">
      <!-- <img class="background" src="./pop_xinyinghu03@2x.png" alt=""> -->
      <div class="wechat">
        <div class="left">微信搜索：ct_tmd</div>
        <div class="right" @click="copy">复制</div>
      </div>
      <div class="activity-detail" @click="handleTextButtonClick">
        活动详情 >
      </div>
    </div>
  </div>
</template>
<script>
import { setKey } from '@/assets/utils'
import { copyToClipbord } from '../../../../assets/utils.js'

export default {
  data () {
    return {
      visible: true
    }
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    open () {
      this.visible = true
      setKey('NEW_COMER_3_SHOW_TIME', Date.now())
    },
    close () {
      this.visible = false
      this.$emit('close')
    },
    handleTextButtonClick () {
      this.$report({
        id: 10124,
        args: {
          target: 3,
          status: this.data.couponDetailType
        }
      })
      this.$router.push({
        path: '/newHumanity/detail',
        query: {
          loanPlatform: 'TMD',
          activeType: this.data.activeType,
          open: 1
        }
      })
    }, 
    copy () {
      this.$report({
        id: 10124,
        args: {
          target: 5,
          status: this.data.couponDetailType,
          id: this.data.couponRecordId
        }
      })
      copyToClipbord('ct_tmd')
      this.$message('已复制到剪贴板')
    },
    show () {
      setKey('NEW_COMER_3_SHOW_TIME', Date.now())
      this.$report({
        id: 50021,
        args: {
          visible: 1,
          target: 'NEW_PERSON', // 免息活动
          step: this.data.nextStep,
          status: 1
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

.red-packet1-dialog {
    .red-packet1-content {
        width: 620px;
        height: 750px;
        border-radius: 30px;
        position: relative;
        background: url('./pop_xinyinghu03@2x.png');
        background-size: 100%;
        .activity-detail {
            position: absolute;
            bottom: 0px;
            left: 50%;
            transform: translateX(-50%);
            text-align: center;
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
            line-height: 40px;
            margin-bottom: 53px;
        }
        .wechat {
            position: absolute;
            display: flex;
            justify-content: space-around;
            top: 540px;
            width: 440px;
            height: 80px;
            left: 50%;
            transform: translateX(-50%);
            background: #FFFFFF;
            border-radius: 10px;
            font-size: 32px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 80px;
            .right {
                color: #FF4633;
            }
        }
    }
}
</style>
